module.exports = __webpack_public_path__ + "static/9gde-59b0a3c7fd1736554f019f28d07444ff.gif";